export default {
      id: "child-education-1-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#child-education-1",
      toString: function () {
        return this.url;
      }
    }